import { getCountryByCode, getLanguageByCode } from 'utils/common'

export const getInitialStates = data => ({
    selectedTags: data && data.tags ? data.tags.map(tag => tag.id) : [],
    title: data?.title || '',
    description: data?.description || '',
    country: getCountryByCode(data?.countryCode),
    language: getLanguageByCode(data?.languageCode),
})
